export default "__VITE_ASSET__DOgEDOdI__"